import { useQuery } from '@apollo/client'
import {
  getReferrals,
  getReferralsVariables,
  ReferralStatus,
} from '../../../../models/graphqlTypes'
import { GET_PATIENT_REFERRALS } from '../../../../operations/patientReferralOperations'

export const usePatientReferralCount = ({
  patientId,
  statuses,
}: {
  patientId: getReferralsVariables['patientId']
  statuses: ReferralStatus[]
}): { total: number; refetch: () => void } => {
  const { data, refetch } = useQuery<getReferrals, getReferralsVariables>(
    GET_PATIENT_REFERRALS,
    {
      fetchPolicy: 'no-cache',
      notifyOnNetworkStatusChange: true,
      variables: {
        patientId,
        filterData: {
          statuses,
        },
      },
    }
  )

  return { total: data?.getReferrals.total ?? 0, refetch }
}
